// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"success_iconContainer__3myFf","msgContainer":"success_msgContainer__3BXDP","btnContainer":"success_btnContainer__2Anfb"};